import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { IconButton, Tooltip } from '@mui/material';

import { deletePageByNumber } from '../../actions/documents';
import { RootState } from '../../store';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = StateProps & DispatchProps;

function RemovePage(props: Props) {
  return (
    <div>
      <Tooltip disableInteractive disableFocusListener id="remove-page-tooltip" title="Remove Page">
        <div>
          <IconButton
            sx={{ borderRadius: 0, width: '100%' }}
            disabled={props.activeDocumentId == null || props.pdfData[props.activeDocumentId].pdfPages.length === 1}
            onClick={() => props.deletePageByNumber(props.activeDocumentId!, props.activePageNumber)}
            aria-label="Remove Page"
          >
            <RemoveCircleIcon />
          </IconButton>
        </div>
      </Tooltip>
    </div>
  );
}

function mapStateToProps(state: RootState) {
  return {
    activeDocumentId: state.documents.activeDocumentId,
    activePageNumber: state.documents.activePageNumber,
    pdfData: state.documents.pdfData,
  };
}

const actionCreators = {
  deletePageByNumber,
};

export default connect(mapStateToProps, actionCreators)(RemovePage);
